
<template>
  <div>
    <dialog-loading v-if="saving" loadingText='Salvando...'></dialog-loading>
    <v-dialog v-model="dialog" persistent max-width="800px" transition="dialog-transition">
      <v-card>
        <v-card-title>
          <span class="headline">Editando carteira de clientes</span>
        </v-card-title>
        <v-card-text>
          <ChooseClientPortfolioForm ref="form" :model="model_aux"></ChooseClientPortfolioForm>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <f-btn cancel @click="closeDialog"></f-btn>
          <f-btn save @click="submitChanges"></f-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Api from '@/api/index';

export default {
  name: 'DialogEditClientPortfolio',
  props: {
    model:{
      type: Object,
      default: () => { return {} }
    },
    change_dialog:{
      type: Boolean,
      default: false
    },
    API:{
      type: Object,
      default: ()=>{
        return {
          MODEL: "Client",
          METHOD: "basicUpdate",
        }
      }
    }
  },
  components: {
    ChooseClientPortfolioForm: () => import("@/_backoffice/_registrations/components/shared/client_portfolio/ChooseClientPortfolioForm.vue")
  },
  data() {
    return {
      dialog: false,
      model_aux: {},
      saving: false
    }
  },
  methods: {
    getData() {
      this.setModelAux()
    },
    prepareData(){
      return {
        id: this.model.id,
        client_portfolio_ids: this.model_aux.client_portfolio_ids
      }
    },
    submitChanges(){
      if(this.$refs.form.validate()){
        this.saving = true
        let updated_data = this.prepareData()
        Api[this.API.MODEL][this.API.METHOD](updated_data).then(()=>{
          this.successUpdated()
          this.$emit('updated')
        }).catch(er => {
          this.errorUpdated()
        }).finally(()=>{
          this.saving = false
        })
      }
    },
    setModelAux(){
      this.model_aux = JSON.parse(JSON.stringify(this.model))
    },
    closeDialog(){
      this.$emit('close')
    }
  },
  computed: {
  },
  mounted() {
    this.getData()
  },
  watch:{
    model(){
      this.setModelAux()
    },
    change_dialog(nv){
      this.dialog = nv
      if(nv){
        this.getData()
      }
    }
  }
}
</script>